import RoundInputText from './RoundInputText';

export default RoundInputText;
